import { AxiosResponse } from 'axios';
import { CancellationAireFormVM } from 'cancellations/view-models/cancellation-aire';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData, SubjectData } from 'shell/models/person';
import { initialValues } from 'cancellations/constants/cancellation-aire';
import { transformGenerality } from 'shell/utils/consult-person/response-transformer/registry-office/generality';
import { ForeignVM } from 'subscription/view-models/common-interface-subscription';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';

const transformAddressForeign = (person: SubjectData): ForeignVM | undefined => {
  const localitaEstera = (person.residenza || [])[0]?.localitaEstera;
  if (!localitaEstera) {
    return undefined;
  }

  return {
    address: localitaEstera.indirizzoEstero?.toponimo?.denominazione || '',
    civicNumber: localitaEstera.indirizzoEstero?.toponimo?.numeroCivico || '',
    cap: localitaEstera.indirizzoEstero?.cap || '',
    consulateCode: localitaEstera.consolato?.codiceConsolato
      ? {
          id: localitaEstera.consolato.codiceConsolato || '',
          value: localitaEstera.consolato.descrizioneConsolato || '',
        }
      : undefined,
    foreignState: localitaEstera.indirizzoEstero?.localita
      ? {
          id: localitaEstera.indirizzoEstero.localita.codiceStato || '',
          value: localitaEstera.indirizzoEstero.localita.descrizioneStato || '',
          province: localitaEstera.indirizzoEstero.localita.provinciaContea || '',
        }
      : undefined,
    municipality: localitaEstera.indirizzoEstero?.localita?.descrizioneLocalita
      ? {
          description: localitaEstera.indirizzoEstero.localita.descrizioneLocalita || '',
          province: localitaEstera.indirizzoEstero.localita.provinciaContea || '',
        }
      : undefined,
  };
};

export const transformerCancellationAireData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): CancellationAireFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || [];

  const generality = transformGenerality(person);

  const personVM = transformPerson(person);

  const addressForeign = transformAddressForeign(person);

  return {
    ...initialValues,
    citizenship: {
      validity: generality?.birthDate,
      state: {
        id: (person?.cittadinanza || [])[0]?.codiceStato || '',
        value: (person?.cittadinanza || [])[0]?.descrizioneStato || '',
      },
    },
    addressForeign,
    generality: {
      ...initialValues.generality,
      ...(generality || {}),
      aire: generality?.aire,
    },
    person: personVM || undefined,
    data: person,
  };
};
